"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const AxiosRetry = __importStar(require("axios-retry"));
const apiOrderToAppOrder_1 = __importDefault(require("../libs/apiOrderToAppOrder"));
const appBatchToApiBatch_1 = __importDefault(require("../libs/appBatchToApiBatch"));
const axiosRetry = AxiosRetry.default;
const retryConfig = {
    retries: 5,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: (error) => { var _a, _b, _c; return ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404 && ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) === 'order not exist'; },
};
class Api {
    constructor(baseUrlGo, baseUrlNode, locale = 'zh') {
        this.locale = locale;
        this.baseUrlGo = baseUrlGo;
        this.baseUrlNode = baseUrlNode;
        this.axiosGo = axios_1.default.create({
            baseURL: baseUrlGo,
        });
        this.axiosNode = axios_1.default.create({
            baseURL: baseUrlNode,
        });
        axiosRetry(this.axiosGo, retryConfig);
        axiosRetry(this.axiosNode, retryConfig);
        this.apiVersion = '2.0.0';
        this.axiosGo.defaults.headers.common['X-Api-Version'] = this.apiVersion;
        this.axiosNode.defaults.headers.common['X-Api-Version'] = this.apiVersion;
    }
    setUrl(baseUrlGo, baseUrlNode) {
        this.axiosGo.defaults.baseURL = baseUrlGo;
        this.axiosNode.defaults.baseURL = baseUrlNode;
    }
    setUpdateUserCallback(callback) {
        this.updateUserCallback = callback;
    }
    setResetUserCallback(callback) {
        this.resetUserCallback = callback;
    }
    setRefreshCustomerApiCallback(callback) {
        this.refreshCustomerApiCallback = callback;
    }
    setToken(token, refresh) {
        this.token = token;
        this.refresh = refresh;
        this.axiosGo.defaults.headers.common.Authorization = `Bearer ${token}`;
        this.axiosNode.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
    setLanguage(locale) {
        this.locale = locale;
        this.axiosGo.defaults.headers.common['Accept-Language'] = locale;
        this.axiosNode.defaults.headers.common['Accept-Language'] = locale;
    }
    logError(error) {
        var _a, _b;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) != null && ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) != null) {
            console.error({
                type: 'ajax error',
                request: {
                    method: error.config.method,
                    url: error.config.url,
                    data: error.config.data,
                    params: error.config.params,
                },
                response: {
                    data: error.response.data,
                    status: error.response.status,
                },
            });
        }
        else {
            console.error(error);
        }
    }
    shortUrl(longUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post('https://s.dimorder.com/api/v1/shorten', { long_url: longUrl });
            return response.data.short_url;
        });
    }
    calculateOrder(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/g/order';
            const { batches, deliveryType, shipping, rounding, surcharge, modifiers, promoCodeId, usedRiceCoin, from, } = params;
            const response = yield this.axiosGo.post(endpoint, {
                batches: batches.map((batch) => {
                    const apiBatch = appBatchToApiBatch_1.default({
                        orderId: '',
                        orderBatch: batch,
                        deliveryType: deliveryType,
                        shipping: shipping,
                        ignoreUnavailable: false,
                        from: from,
                    });
                    apiBatch.status = 'submitted';
                    return apiBatch;
                }),
                deliveryType,
                shipping: deliveryType === 'storeDelivery'
                    ? Object.assign(Object.assign({}, shipping), { customerAmount: shipping.totalFee }) : null,
                rounding,
                surcharge: deliveryType === 'table'
                    ? surcharge
                    : null,
                modifiers,
                promocode: promoCodeId,
                riceCoin: usedRiceCoin,
            });
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
}
exports.default = Api;
//# sourceMappingURL=Api.js.map